export default __webpack_public_path__ + "static/media/nomina_banner.2c96a1e0.png";